import {
  eolsBaseApi,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';
import {
  AppLinkCookies,
  AppLinkData,
} from './eols-app-link.dtos';
import {
  Application,
} from './eols-app-link.constants';
import {
  AppLinkOutConfig,
  AppLinkOutResponse
} from './eols-app-link.models';
import { addSearchParams } from '../../utilities/app.utilities';

export const getAppLinkApiUrl = (config: AppLinkOutConfig): string => {
  const { app, action } = config;
  if (app === Application.EPM_SKILL) {
    return `/sherpath/course-management/skill/app-link/${action}`;
  }
  const queryParams = {
    linkId: config.linkId,
    includeLinkHash: config.includeLinkHash,
    isCrossDomain: config.isCrossDomain,
    altSrcApp: config.altSrcApp,
    parentLinkId: config.parentLinkId
  };
  return addSearchParams(`/app-link/out/${app}/${action}`, queryParams);
};

export const getExternalAppRedirectUrl = (
  config: AppLinkOutConfig,
  token?: string
): Promise<AppLinkOutResponse> => {

  const headers = token ? {
    Authorization: `Bearer ${token}`
  } : {};

  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post<AppLinkOutResponse>(
      getAppLinkApiUrl(config),
      {
        ignoreToken: true,
        data: config.body
      },
      headers
    );
  });
};

export const getLinkNavigation = (
  props: {
    linkId: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    returnPostBody: any;
  }
): Promise<AppLinkOutResponse> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post<AppLinkOutResponse>(
      `/app-link/return/${props.linkId}`,
      props.returnPostBody ? { data: props.returnPostBody } : null
    );
  });
};

export type HashLinkDto = AppLinkCookies;

export const fetchHashLink = (hashLink: string): Promise<HashLinkDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<HashLinkDto>(`/app-link/hash-link/${hashLink}`, {
      headers: {
        'X-App-ID': Application.STUDENT_STUDY
      }
    });
  });
};

export const fetchAppLinkData = (key: string): Promise<AppLinkData> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<AppLinkData>(`/app-link/data/${key}`);
  });
};
